import { useMatches } from "react-router";
import AdSettings from "@components/Advertisement/AdSettings";
import { useBtSdkAdsCanaryConfigContext } from "@components/Advertisement/BtSdkAdsCanaryConfigContext";
import GAData from "@components/GAData/GAData";
import { getLoaderData } from "@helpers/getLoaderData";
import { HttpStatusCode } from "axios";

const ConfigurationSettings = (): React.ReactElement => {
  const matches = useMatches();
  const sdkAdsConfig = useBtSdkAdsCanaryConfigContext();
  const currentMatch = matches[matches.length - 1];
  const loaderData = getLoaderData(currentMatch);

  if (loaderData && loaderData.statusCode !== HttpStatusCode.Ok) return <></>;
  if (typeof loaderData?.payload === "undefined") return <></>;
  if (typeof loaderData?.payload === "string") return <></>;

  const adSettings = loaderData.payload.adSettings;
  const gaProps = loaderData.payload.gaProps;
  const isSdkAdsEnabled = typeof sdkAdsConfig !== "undefined";

  return (
    <>
      {adSettings && !isSdkAdsEnabled ? <AdSettings {...adSettings} /> : null}

      {gaProps ? (
        <GAData {...gaProps} legacyPermutiveEnabled={!isSdkAdsEnabled} />
      ) : null}
    </>
  );
};

export default ConfigurationSettings;
